export default "__VITE_ASSET__DInga760__"